import { IConstraintFacilityInitialBuildDetail } from '../../interfaces/iconstraint-facility-initial-build-detail';
import { Area } from '../area';
import { ConstraintFacilityInitialBuild } from '../constraint-facility-initial-build';

export class ConstraintFacilityInitialBuildDetailBase {
  ConstraintFacilityInitialBuildDetailId: number;
  ConstraintFacilityInitialBuildId: number;
  AreaId: number | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  ConstraintFacilityInitialBuild?: ConstraintFacilityInitialBuild;

  constructor(item?: IConstraintFacilityInitialBuildDetail) {
    if (item) {

      this.ConstraintFacilityInitialBuildDetailId = item.ConstraintFacilityInitialBuildDetailId;
      this.ConstraintFacilityInitialBuildId = item.ConstraintFacilityInitialBuildId;
      this.AreaId = item.AreaId;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.ConstraintFacilityInitialBuild = new ConstraintFacilityInitialBuild(item.ConstraintFacilityInitialBuild);
    }
  }
}